import request from '@/utils/request';

//校审核或者区域审核
export const schoolAuditOrAreaAudit = data => {
    return request({
        url: '/api/audit/schoolAudit',
        method: 'post',
        data
    });
};

//校审核,学段审核,或者退回修改课题申报详情
export const TopicDeclarationDetail = id => {
    return request({
        url: '/api/eduSubjectDeclare/list/' + id,
        method: 'get',
    });
};

// 获取pdf文件流
export const getPdfFile = (id) => {
    return request({
        url: `/upload/downloadPdf/${id}`,
        method: 'get',
    });
};
// 获取学校审核表格文件流
export const getSchoolAuditExcel = (projectId, type) => {
    return request({
        url: `/api/excel/schoolAuditExcel/${projectId}/${type}`,
        method: 'get',
        responseType: "blob"
    });
};